// removed by extract-text-webpack-plugin
module.exports = {"root":"_3NV_6keU6VQI9vGjP5K15K","response":"_2itwslfZGpSGrpicwv2d4v","option":"_1Z2a9BHLKfnr6azOAFy7tJ","sound-list":"OwTgAKWBY_6-KjOIJk27V","image-list":"_3Omrn97MbeeqjNM21qzNDn","image":"Z9KotRcGQ3Vr5krDGafTr","image-remove-button":"_2nNcaJslSXE2vhwpH_keJP","number":"ZfLTH0LK-g3fEro_DAXKV","center-value":"_3H3_NMl2ZQmCSCRuqWD-bG","exempt-content":"_1JkWeXAS0wKUmcJyjJskUa","question-meta":"_2IPwCOoNEfjs8UxISB0U97","description":"IcucX6lrBJ9BUkIz2W-pS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/submissions/show/answer-list.scss
// module id = 1605
// module chunks = 0